<template>
    <div class="project_modular ">
        <div id="project_distribution_echarts">
        </div>
    </div>
</template>
<script>
import util from "@/mixins/util";
import * as echarts from "echarts";
import "echarts-liquidfill";
import "@/util/echarts-auto-tooltip";

export default {
    name: 'projectDistribution',
    mixins: [util],
    data() {
        return {
            chart: null,

            tooltipTimerGet: null,
            dictionaryData:{

            }
        }
    },
    props: {
        dataInfo: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    beforeDestroy() {
        if (!this.chart) {
            return;
        }
        this.tooltipTimer.clearLoop();
        this.chart.dispose();
        this.chart = null;
    },
    async mounted() {
        let dataList = [
        { code: "zs_project_status", name: "zsProjectStatusList" },
        ];
        let dictionaryData = await this.dictionaryAllMap(dataList);
        this.dictionaryData = dictionaryData

        // this.initChart();
    },
    methods: {
        initChart() {
            let that = this
            this.chart = echarts.init(
                document.getElementById("project_distribution_echarts")
            );
            window.addEventListener("resize", function () {
                if (that.chart) {
                    that.chart.resize();

                }
            });
            this.$nextTick(() => {
                this.getDetail();
            });
        },
        async getDetail() {
            let typeCountList=this.dataInfo.projectStatusList.map(item=>{
                return {
                    name:this.dictionaryLabel(item.projectStatusCode, this.dictionaryData.zsProjectStatusList),
                    value:item.projectStatusCount
                }
            })

             
            this.setOptions(typeCountList);

        },
        setOptions(data) {
            let option = {
                color: ["#0abaff", "#07e8ae", "#F2637B", "#FBD337", "#59D4D4", "#4ECB73", '#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'],
                title: {
                    text: '',
                    left: 'center',
                    top: 10,
                },
                tooltip: {
                    trigger: "item",
                    show: true,
                },
                legend: {
                    show: true,
                    orient: "horizontal",
                    x: "center",
                    y: "3%",
                    icon: "circle",
                    itemWidth: 16,
                    itemHeight: 16,
                    // itemGap: 20,
                    align: "auto",
                    type: 'scroll',
                    textStyle: {
                        padding: [1, 0, 0, 0]
                    },
                },
                series: [
                    {
                        type: "pie",
                        radius: "65%",
                        center: ["50%", "50%"],
                        data: data,
                        label: {
                            show: true,
                            normal: {
                                show: true,
                                formatter: ["{b|{b}:}{d|{d}%}"].join("\n"),
                                position: "outside",
                                rich: {
                                    b: {
                                        fontSize: 12,
                                        padding: [0, 0, 0, 2],
                                    },
                                    c: {
                                        fontSize: 12,
                                        padding: [2, 0, 0, 10],
                                        align: "left",
                                    },
                                },
                            },
                        },
                        itemStyle: {
                            // normal: {
                            //     borderWidth: 2,
                            //     borderColor: '#ffffff',
                            // },
                        },
                        emphasis: {
                            itemStyle: {
                                borderWidth: 3,
                                borderColor: '#ffffff',
                            },
                        },
                    },
                ],
            };

            this.tooltipTimer =
                // = autoHover(this.chart, option, 3, 3000);
                // eslint-disable-next-line no-undef
                tools.loopShowTooltip(this.chart, option, {
                    loopSeries: true,
                });
            this.chart.setOption(option);
        },
        updateChart(){
            this.tooltipTimer.clearLoop();
            this.getDetail();
        }

    }

}
</script>
<style lang="scss" scoped>
$base_width: 1920;
$base_height: 1080;

@function vw($px) {
    @return ($px / $base_width) * 100vw;
}

@function vh($px) {
    @return ($px / $base_height) * 100vh;
}

.project_modular {
    height: vh(445);
    #project_distribution_echarts {
        width: 100%;
        height: vh(445);
    }


}
</style>
